import './options-toolbar.scss'

import { Component, Watch } from 'vue-property-decorator'
import { faSortAmountDown, faSortAmountUp } from '@fortawesome/free-solid-svg-icons'

import { SearchParams, SortFilter } from '@skinsoft/types'
import { EntityFieldDataStore } from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'

@Component({
    props: ['sortingEntityFields'],
    template: require('./options-toolbar.html'),
})
export class OptionsToolbar extends ReactiveVue {

    public sortingEntityFields: SortFilter[]

    private sortOptions: any[] = [];
    private $entityFieldDataStore: EntityFieldDataStore;

    // Icons
    private sortAscIcon = faSortAmountUp;
    private sortDescIcon = faSortAmountDown;

    private options: Partial<SearchParams> = {
        sortAsc: false,
        sortType: '',
    };

    public async populateSelectOptions() {
        let index = 0;
        // Setting options from config file
        for (const entityField of this.sortingEntityFields) {
            try { // the try catch is to continue on error and not fail for all entityFields if one fail
                let entityFieldId = entityField.id
                if(!entityFieldId && entityField.entityFieldName && entityField.entityName && entityField.schemaName) {
                    entityFieldId = await this.$entityFieldDataStore.getEntityFieldId(
                        entityField.entityFieldName,
                        entityField.entityName,
                        entityField.schemaName
                    )
                }
    
                this.sortOptions.push({
                    label: entityField.i18nKey,
                    value: entityFieldId
                })
    
                // Setting default sort option (first in config file)
                if (index === 0) {
                    this.options.sortType = entityFieldId;
                }
                index++
            } catch(err) {}
        }
    }
    private toggleSortAsc() {
        this.options.sortAsc = !this.options.sortAsc;
    }

    @Watch('options', { immediate: true, deep: true })
    private onValueChange() {
        this.$emit('change', this.options);
    }

    @Watch('sortingEntityFields')
    private onSortingEntityFieldsChange() {
        this.populateSelectOptions()
    }
}
